<template>
  <li class="ui-sortable-handle" :class="{'user_group_item': isUserCarousel}" :id="id">
    <span class="group_name">{{name}}</span>
    <span class="actions" v-if="$_updateActionAllowed">
      <a @click.stop.prevent="goToDetail" class="edit" :title="'Upravit' |translate">Upravit</a>
    </span>
  </li>
</template>

<script>
export default {
  name: "CarouselListItem",
  props: {
    name: String,
    isUserCarousel: Boolean,
    id: Number,
    idSubscriber: Number
  },
  methods: {
    goToDetail(){
      if(this.isUserCarousel) {
        this.$router.push({name: 'subscriberDetailDashboardCarousel', params: {idSubscriber: this.idSubscriber, id: this.id}})
      }else{
        this.$router.push({name: 'dashboardCarouselDetail', params: {id: this.id}})
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/dashboard/CarouselListItem.vue